import type Module from 'mini-common-schema/lib/schema/Module';
import switchModule from 'owa-mail-store/lib/actions/switchModule';
import { convertRestIdToEwsId } from 'owa-identifiers';
import { getDefaultFolderToLoad } from 'mini-mail-folder-store/lib/utils/getDefaultFolderToLoad';
import { getMailItemFromItemId } from 'owa-mail-store/lib/store/selectors/getMailItemFromItemId';
import { isFeatureEnabled } from 'owa-feature-flags';
import { lazyLoadItem } from 'mini-mail-load-conversation';
import { lazyReplyToMessage } from 'mini-mail-compose-actions-mail';
import { logUsage } from 'owa-analytics';
import { REPLY_ACTION_FROM_NOTIFICATION } from 'mini-mail-workflow-tracking/lib/constants/ListViewWorkflowConstants';
import { REPLY_ACTION_FROM_NOTIFICATION_BEGIN } from 'mini-mail-workflow-tracking/lib/constants/ListViewWorkflowConstants';
import { REPLY_ACTION_FROM_NOTIFICATION_FAILED } from 'mini-mail-workflow-tracking/lib/constants/ListViewWorkflowConstants';
import { tryHydratingListView } from '../utils/tryHydratingListView';

import type Message from 'owa-service/lib/contract/Message';

export interface MailReplyRouteHandlerParams {
    itemId: string;
    immutableItemId: string;
}

/**
 * Primary use case:
 * Push Notifications :- To open appropriate reply compose on click of reply mail action from new mail push notification.
 */
export async function mailReplyRouteEntryHandler(
    params: MailReplyRouteHandlerParams
): Promise<void> {
    logUsage(REPLY_ACTION_FROM_NOTIFICATION_BEGIN, {}, { isCore: true });

    // When we reach a mail folder route, switch selected module to mail
    switchModule(0);

    try {
        const itemId = isFeatureEnabled('fwk-immutable-ids')
            ? convertRestIdToEwsId(params.immutableItemId)
            : convertRestIdToEwsId(params.itemId);

        let message = getMailItemFromItemId(itemId) as Message;
        if (!message) {
            const loadItem = await lazyLoadItem.import();
            message = (await loadItem(itemId)) as Message;
        }

        lazyReplyToMessage(message, 'Notification', false /*isReplyAll*/);

        // Hydrate the store with mails from Others Inbox, in case notification is from that.
        tryHydratingListView(getDefaultFolderToLoad());
        logUsage(REPLY_ACTION_FROM_NOTIFICATION, {}, { isCore: true });
    } catch (error) {
        logUsage(REPLY_ACTION_FROM_NOTIFICATION_FAILED, { error: error }, { isCore: true });
    }
}
